import keycloak from './keycloak'
import { forgetPushOnSignOut } from '../lib/push'

// signOut is the only way the site signs a person out on purpose: it first unlinks this browser
// from the account's pushes (a shared computer must not keep showing them), then ends the Keycloak
// session. accountGone skips telling the server, which already dropped the deleted account's rows.
export async function signOut(
  redirectUri: string = window.location.origin,
  { accountGone = false }: { accountGone?: boolean } = {},
): Promise<void> {
  await forgetPushOnSignOut({ tellServer: !accountGone })
  await keycloak.logout({ redirectUri })
}
